export default {"src":"/_next/static/media/google-play-badge-en.93a7d750.svg","height":54,"width":180,"blurWidth":0,"blurHeight":0};